import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authorization-gate/wizard/admin')({
	staticData: {
		authorize: (ability) => ability.can('manage', 'wizardAdmin'),
	},
	head: () => ({ meta: [{ title: 'Wizard Admin • Cadstrom' }] }),
});
